var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('a',{staticClass:"text-decoration-none",attrs:{"href":_vm.link,"target":"_blank"}},[_c('v-btn',{attrs:{"icon":"","outlined":"","height":_vm.size,"width":_vm.size,"color":_vm.color},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{style:({
        fontSize: `${+_vm.size - 4}px !important`,
      })},[_vm._v(" ? ")])])],1):_c('v-btn',{attrs:{"icon":"","outlined":"","height":_vm.size,"width":_vm.size,"color":_vm.color},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{style:({
      fontSize: `${+_vm.size - 4}px !important`,
    })},[_vm._v(" ? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }